import { render, staticRenderFns } from "./wiev-button.vue?vue&type=template&id=0bc8e871&"
import script from "./wiev-button.vue?vue&type=script&lang=ts&"
export * from "./wiev-button.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports